// extracted by mini-css-extract-plugin
export default {"root":"fUcpPxBCH9","root_stretchedX":"ntL9py0MCG","root_stretchedY":"kKurwvDhaK","iframe":"mnnaM1A_HO","iframe_stretchedX":"_OjysvTSLn","iframe_stretchedY":"iMG0r93yBO"};